import { openBlock as t, createElementBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
};
function l(a, e) {
  return t(), o("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M7.556 3.938a3.29 3.29 0 0 1 4.602 0 3.17 3.17 0 0 1 0 4.532L7.556 13 2.953 8.47a3.17 3.17 0 0 1 0-4.532 3.29 3.29 0 0 1 4.482-.113z"
    }, null, -1)
  ])]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
